var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5224 41.0039C16.9011 41.0001 12.4232 39.401 8.84707 36.4774C5.27089 33.5539 2.81624 29.4855 1.89885 24.9613C0.981459 20.4372 1.65771 15.7354 3.81308 11.6522C5.96844 7.56898 9.47044 4.35541 13.726 2.5557C18.6178 0.51071 24.1216 0.486008 29.0316 2.48701C33.9416 4.48801 37.8573 8.35153 39.9208 13.231C41.9842 18.1105 42.0272 23.6081 40.0401 28.5192C38.0531 33.4302 34.1982 37.3543 29.32 39.4315C26.8532 40.4744 24.201 41.0092 21.5224 41.0039V41.0039ZM14.1176 20.9942L12.3127 22.7964L18.7489 29.2253L31.7969 16.1926L29.9876 14.3904L18.7437 25.6216L14.1176 20.9942Z",
    fill: "#00C1AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/IconCheck.a455118c.svg";
export { ForwardRef as ReactComponent };